// extracted by mini-css-extract-plugin
module.exports = {"DiagramDisplayWrapper":"DiagramDisplay_DiagramDisplayWrapper__2CVCx"};